import { Routes } from '@angular/router';
import { authGuard, noAuthGuard, roleGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layout/layout/layout.component';
import { AccessdeniedComponent } from './shared/components/accessdenied/accessdenied.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { Dashboard } from './modules/dashboard/dashboard';
import { nfcAuthGuard } from './core/guards/nfc-auth.guard';
import { nfcRestrictedGuard } from './core/guards/nfc-restricted.guard';
import { AccountComponent } from './modules/dashboard/account/account.component';
import { DocumentacionArcoComponent } from './modules/aplicaciones/documentacion-arco/documentacion-arco.component';
import { TicketsLumatComponent } from './modules/aplicaciones/tickets/tickets-lumat.component';
import { InformesComponent } from './modules/aplicaciones/informes/informes.component';
import { ManualComponent } from './modules/aplicaciones/manual/manual.component';
import { GnbValidacionComponent } from './modules/aplicaciones/gnb-validacion/gnb-validacion.component';
import { MEDICAL_REPORT_REQUESTS_ROLES } from './modules/medical-reports/core/constants/medical-report-roles';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'sys',
        component: LayoutComponent,
        // 🔥 IMPORTANTE: Aplicar los guards en el orden correcto
        // 1️⃣ authGuard - Verifica autenticación básica
        // 2️⃣ nfcAuthGuard - Verifica NFC si el usuario lo requiere
        // 3️⃣ nfcRestrictedGuard en canActivateChild - se ejecuta en CADA navegación
        //    a cualquier hijo (los canActivate del padre solo corren al activar /sys)
        canActivate: [authGuard, nfcAuthGuard],
        canActivateChild: [nfcRestrictedGuard],
        children: [
            {
                path: 'dashboard',
                data: { breadcrumb: 'Inicio' },
                component: Dashboard
            },
            {
                path: 'profile',
                component: AccountComponent
            },
            {
                path: 'identity',
                // Para rutas hijas también puedes aplicar guards adicionales
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['ROOT', 'ADMIN', 'RRHH', 'CONTADOR', 'ENCARGADO', 'RADIOLOGO', 'SECRETARIA', 'COBRANZA'] },
                loadChildren: () => import('./modules/identity/views/identity.routes')
            },
            {
                path: 'settings',
                // Para rutas hijas también puedes aplicar guards adicionales
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['ROOT', 'COBRANZA'] },
                loadChildren: () => import('./modules/settings/views/settings.routes')
            },
            {
                path: 'cashier',
                loadChildren: () => import('./modules/cashier/views/cashier.routes')
            },
            {
                path: 'cash/petty-cash',
                loadChildren: () => import('./modules/petty-cash/views/petty-cash.routes')
            },
            {
                path: 'cashier-reports',
                loadChildren: () => import('./modules/cashier-reports/views/cashier-reports.routes')
            },
            {
                path: 'clinical',
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['ROOT', 'ADMIN', 'RRHH', 'CONTADOR', 'ENCARGADO', 'RADIOLOGO', 'SECRETARIA', 'COBRANZA'] },
                loadChildren: () => import('./modules/clinical-care/views/clinical-care.routes')
            },
            {
                path: 'reports',
                loadChildren: () => import('./modules/clinical-care/views/reports/reports.routes')
            },
            {
                path: 'marketing',
                loadChildren: () => import('./modules/marketing-reports/views/marketing-reports.routes')
            },
            {
                path: 'bancard',
                loadComponent: () => import('./modules/bancard/bancard-reconcile.component').then((m) => m.BancardReconcileComponent)
            },
            {
                path: 'purchase-orders',
                loadChildren: () => import('./modules/purchase-orders/views/purchase-orders.routes')
            },
            {
                path: 'contabilidad',
                loadChildren: () => import('./modules/contabilidad/views/contabilidad.routes')
            },
            {
                path: 'rrhh',
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: ['ROOT', 'ADMIN', 'RRHH', 'CONTADOR'] },
                loadChildren: () => import('./modules/rrhh/views/rrhh.routes')
            },
            {
                path: 'medical-reports',
                canActivate: [roleGuard, nfcAuthGuard],
                data: { roles: MEDICAL_REPORT_REQUESTS_ROLES },
                loadChildren: () => import('./modules/medical-reports/views/medical-reports.routes')
            },
            {
                path: 'aplicaciones/manual',
                component: ManualComponent
            },
            {
                path: 'aplicaciones/documentacion-arco',
                component: DocumentacionArcoComponent
            },
            {
                path: 'aplicaciones/tickets-lumat',
                component: TicketsLumatComponent
            },
            {
                path: 'aplicaciones/informes-arco',
                component: InformesComponent
            },
            {
                path: 'gnb',
                loadComponent: () => import('./modules/gnb/views/gnb-test/gnb-test.component').then((m) => m.GnbTestComponent)
            }
            // ,
            // {
            //     path: 'aplicaciones/documentacion-arco',
            //     component: DocumentacionArcoComponent
            // },
        ]
    },

    {
        path: 'auth',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes')
    },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'denied', component: AccessdeniedComponent },
    { path: '**', redirectTo: '/notfound' }
];
